export const MICROSOFT_AZURE = 11;

export const swalDefaultConfig = {
  title: "Are you sure?",
  icon: "warning",
  closeOnClickOutside: false,
  className: "sn-m-modal",
  buttons: {
    cancel: {
      text: "No",
      value: null,
      visible: true,
      className: "sn-btn sn-btn-sm sn-btn-silver",
      closeModal: true,
    },
    confirm: {
      text: "Yes",
      value: true,
      visible: true,
      className: "sn-btn sn-btn-sm sn-btn-red",
      closeModal: true,
    },
  },
  dangerMode: true,
};
